import * as apiClient from "./httpCommon";
import { apiRoutes } from "../helper";


export const userLogin = async (data) => (await apiClient.postAPICall(apiRoutes.userLogin, data));
export const logout = async (data) => (await apiClient.postAPICall(apiRoutes.logout));
export const loginWithOTP = async (data) => (await apiClient.postAPICall(apiRoutes.loginWithOTP, data));
export const validateOTP = async (data) => (await apiClient.postAPICall(apiRoutes.validateOTP, data));
export const fetchTeacherClasses = async (data) => (await apiClient.postAPICall(apiRoutes.fetchTeacherClasses, data));
export const fetchTeacherSectionsBasedonClass = async (data) => (await apiClient.postAPICall(apiRoutes.fetchTeacherSectionsBasedonClass, data));
export const fetchTeacherSubjectsBasedonSection = async (data) => (await apiClient.postAPICall(apiRoutes.fetchTeacherSubjectsBasedonSection, data));
